import 'styles/sitemap.scss'
import {Urls} from '../constants/index.js'



(function () {
    /* global $ */
    'use strict';
    function createPage() {
        createBody();
    }

    function createBody() {
        $('.js-siteMap').append(
            `<section class="cm-template container">
                <div class="cm-template-body">
                    <div class="cm-template-body-location" role="navigation" aria-label="You are here:">
                        <span>
                            <a class="pcg-contrast__link" href="/s4s/CustomPage/Index/${Urls.homePage}">
                                Home <i class="fas fa-angle-right"></i></a>
                            <span class="cm-template-body-location-content pcg-contrast__color-main">Site Map</span>
                        </span>
                    </div>
                    <h1>Site Map</h1>
                          
                    <div class="pcg-content-page">
                        <div class="pcg-content-grid pcg-content-page__content">
                            <div class="pcg-content-grid__mainbar">
                                <div class="pcg-content-page__block pcg-rte-wrapper pcg-contrast-rte">
                                    <div class="pcg-text-block">
                                        <div class="pcg-rte-wrapper pcg-contrast-rte">
                                            <h2 id="home">
                                                <a href="/s4s/CustomPage/Index/${Urls.homePage}?homepage=view">Bath & North East Somerset, Swindon and Wiltshire Home</a>
                                            </h2>
                                            <ul class="bull">

                                                <li><a href="/s4s/CustomPage/Index/${Urls.searchProfilePage}" class="pcg-contrast__link">Search Profile</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.homePage}" class="pcg-contrast__link">Connect</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.siteMap}" class="pcg-contrast__link">Site Map</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.eLearning}" class="pcg-contrast__link">E Learning</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.cvBuilder}" class="pcg-contrast__link">CV Builder</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.contentPage}" class="pcg-contrast__link">Content Page</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.landingPage}" class="pcg-contrast__link">Landing Page</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.aboutPage}" class="pcg-contrast__link">About this</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.infoForProvidersPage}" class="pcg-contrast__link">Info For Providers</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.infoForEmployersPage}" class="pcg-contrast__link">Info For Employers</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.registerPage}" class="pcg-contrast__link">Register</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.privacyPolicyPage}" class="pcg-contrast__link">Privacy Policy</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.accessibilityPage}" class="pcg-contrast__link">Accessibility</a></li>
                                                <li><a href="/s4s/CustomPage/Index/${Urls.termsPage}" class="pcg-contrast__link">Terms</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>`
        );
    }



    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
            createPage();
        },

        bindUIActions: function () {
        },

        unload: function () {},
    };

    Attributes.init();
})();
